'use client';

const BADGE_LABEL_MAX = 34;
export {
  BADGE_LABEL_MAX
};
